import React from "react"
import { Grid, Typography } from "@mui/material"
import { AlertSeeker, DatePickerSeeker, disabledBefore, disabledBeforeToday } from "@ui-seeker/core"
import { useReportExecutionDatesMultiple } from "Pages/ReportsAlerts/Reports/@hooks"


export default function ReportMultiModalExecutionDatesSection() {

	const {
		executionDateMin,
		executionDateMax,
		setExecutionDateMin,
		setExecutionDateMax
	} = useReportExecutionDatesMultiple()

	return <Grid container spacing={2}>
		<Grid item xs={12} sx={{ borderBottom: "2px solid", borderColor: "primary.main" }}>
			<Typography variant="h5">Edit Execution Date Range:</Typography>
		</Grid>
		<Grid item xs={12}>
			<AlertSeeker
				disableAccordion
				isOpen={true}
				severity="info"
				title="Heads up!"
				open={true}
			>
				<Typography variant="body1" color="textSecondary" paragraph>
					Submit with both fields empty to clear the execution date range (set both to null) on every selected report.
				</Typography>
			</AlertSeeker>
		</Grid>
		<Grid item xs={6}>
			<DatePickerSeeker
				cleanable
				label="Date Min Execution"
				shouldDisableDate={disabledBeforeToday()}
				value={executionDateMin}
				inputProps={{ sx: { backgroundColor: "background.grey" } }}
				onChange={e => setExecutionDateMin(e)}
			/>
		</Grid>
		<Grid item xs={6}>
			<DatePickerSeeker
				cleanable
				label="Date Max Execution"
				shouldDisableDate={disabledBefore(executionDateMin)}
				value={executionDateMax}
				inputProps={{ sx: { backgroundColor: "background.grey" } }}
				onChange={e => setExecutionDateMax(e)}
			/>
		</Grid>
	</Grid>
}
